import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router';
import { getCourseData } from '../../courseData';

const Lessons = () => {
  type CoursePageProps = {
    id: number,
    name: string,
    description: string,
    price: number,
    image: { Location: string },
    instructor: { name: string };
    details: string,
    lessons: { }
    updatedAt: string;
  }
  type LessonProps = {
    title: string,
    content: string,
    video: {Location: string}
  }
  const params = useParams();
  const [course, setCourse] = useState<CoursePageProps | any>([]);

  useEffect(() => { 
    (async () => setCourse(await getCourseData()))();
  }, []);
  console.log(course);
  
  return (
    <div>
      {course.map((course: { id: number; slug: string; name: string; description: string; category: string; price: number; image: { Location: string }; instructor: { name: string }; details: string; updatedAt: string; lessons: [LessonProps]; }) => { 
        
          return (
            <div>
              {course.lessons.map((lesson: LessonProps) => {
                if (lesson.title === params.title) {
                  return (
                    <div>
                      <video src={lesson.video?.Location} controls></video>
                    </div>
                    
                  )
                  
                }
                return null;
              })}
            </div>
          )
        
      })}
    </div>
  )
}

export default Lessons